import { Checkbox, Snackbar } from "@material-ui/core";
import axios from "../../../components/Api/Axios";
import React, { useEffect, useState } from "react";
import BackendServices from "../../../components/Api/BackendService";
import { getCompanyId, getUserId, isMegatronProUser } from "../../../Authentication/Auth";
import { number } from "../../../Enums/ValidationRule";
import GlobalError from "../../../routing/GlobalError";
import setError from "../../../store/error/actions/setError";
import { dispatch } from "../../../components/App/App";
import HttpStatus from "../../../components/Api/HttpStatus";
import DialogBox from "../../../components/DialogBox";
import { trackEvent } from "../../../util/googletagmanager/GTM";

interface FavProps {
  id?: string|number
  fav: boolean
}
const FavCheckbox = ({ id, fav }: FavProps) => {
  const [isOpen, setOpen] = useState(false);
  const onClose = () => {
    setOpen(false);  
  };
   const megatronProUser = getUserId() != undefined &&  isMegatronProUser() ;
  const [verifyFavCurrentLimit, setCurrentLimit] = useState("0");
  const [isChecked, setIsChecked] = useState(fav);
  const auditId = Number(id);
  const companyId = Number(getCompanyId());
  const handleCheckboxChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const checkboxStatus = event.target.checked;
    setIsChecked(checkboxStatus);
       if(megatronProUser ){
                               trackEvent('Feature_Interaction',{
                               User_Role:"Company user Pro",
                               Tab_Section:"Certificate Tracker",
                               Type:"Checkbox",
                               Feature_Function:"Favourites",
                               UserInput:"Checkbox"})
                             }
    if (checkboxStatus) {
      axios
        .post(`${BackendServices.AUDIT_SERVICE.VERIFY}/updateFavouriteAudits`,
          { auditId, companyId }
        ).then(({ data }) => {
          const dataString = JSON.stringify(data);
          if (dataString.includes("-1")) {
            setIsChecked(false);
            setOpen(true);
            var currentLimit= dataString.split(',')[1].split('"')[0];
            setCurrentLimit(currentLimit);
           //console.log(dataString);
           
            // dispatch(
            //   setError(
            //     "Maximum number of favourited audits reached" 
            //   )
            // );
          }
        }
        )
        .catch((error) => {
          console.error("Error updating favourite audits:", error);
        });
    }
    else {
      axios
        .post(`${BackendServices.AUDIT_SERVICE.VERIFY}/removeFavouriteAudits`,
          { auditId, companyId }
        )
    }

    // collect data to store

  }
  useEffect(() => {
    setIsChecked(fav)
  }, [id]);


  return (
    <>
      <DialogBox
          onCancel={onClose}
          open={isOpen}
          onConfirm={onClose}
          acceptButtonText="Close"
        >
       <label>  Favourites limit reached.
To request an extension, please select "Favourites Extension request" from the "Assistance" option.</label>
</DialogBox>
    <Checkbox
      key={id}
      checked={isChecked}
      onChange={handleCheckboxChange} /> <GlobalError /></>
  )
}

export default FavCheckbox;